import * as React from "react";
import { cn } from "../../lib/utils";
import { typographyVariants } from "./constants";
import { TypographyProps } from "./types";

const Typography = React.forwardRef<HTMLElement, TypographyProps>(
    ({ className, variant, size, weight, color, as: Comp = "p", ...props }, ref) => {
        return (
            <Comp
                className={cn(typographyVariants({ variant, size, weight, color }), className)}
                ref={ref}
                {...props}
            />
        );
    }
);
Typography.displayName = "Typography";

export { Typography, typographyVariants }; 